/**
 * Renderer for the description column.
 *
 * Preserves the legacy <wbr> soft-wrap behavior from DescriptionCell.jsx.
 */
import React from 'react';
export function InspectionDescriptionRenderer({ item }) {
    if (!item.description)
        return React.createElement("span", null);
    const parts = item.description.split('<wbr>');
    return (React.createElement("span", null, parts.map((part, i) => (React.createElement(React.Fragment, { key: i },
        part,
        i < parts.length - 1 && React.createElement("wbr", null))))));
}
